<div class="header-container">
    <app-header></app-header>
    
</div>
<div>
    <app-snackbar></app-snackbar>
    <router-outlet></router-outlet>
</div>
